import { useState } from 'react';

type Folder = {
  label: string;
  id: string;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useProviderPath = (siteRequired?: boolean) => {
  const [site, setSite] = useState<Folder>();
  const [drive, setDrive] = useState<Folder>();
  const [folders, setFolders] = useState<Folder[]>([]);

  const selectSite = (label: string, id: string) => {
    setSite({ label, id });
    setDrive(undefined);
    setFolders([]);
  };

  const selectDrive = (label: string, id: string) => {
    if (siteRequired && !site) {
      return;
    }
    setDrive({ label, id });
    setFolders([]);
  };

  const enterChildFolder = (label: string, id: string) => {
    if (siteRequired && !site) {
      return;
    }
    if (!drive) {
      return;
    }

    setFolders([...folders, { label, id }]);
  };

  const selectPrevious = (id: string) => {
    const selected = folders.findIndex((folder) => folder.id === id);
    if (selected > -1) {
      setFolders(folders.slice(0, selected + 1));
      return;
    }
    if (drive && drive.id === id) {
      setFolders([]);
      return;
    }
    if (site && site.id === id) {
      setFolders([]);
      setDrive(undefined);
    }
  };

  const selectRoot = () => {
    setSite(undefined);
    setDrive(undefined);
    setFolders([]);
  };

  return {
    site,
    drive,
    folders,
    enterChildFolder,
    selectRoot,
    selectSite,
    selectDrive,
    selectPrevious,
  };
};
